import { CS_IN_SCHOOLS_AUTHOR_ID } from 'global/constants';

export const useCsInSchool = (authorId: number | undefined) => {
  return {
    isCsInSchoolsLesson: CS_IN_SCHOOLS_AUTHOR_ID === authorId,
  };
};
